import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { getCurrentUser, isTokenValid, logOut } from '../../util/service'
import Wallet from '../Wallet'
import PhantomModal from '../Common/PhantomModal'
import ModalBridge from '../Common/ModalBridge'
import baseUrls from '../../util/config'

export default class extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isMobile: false,
            isMenuOpen: false,
            isOptionsOpen: false,
            isNFTModalOpen: false,
            isBridgeOpen: false
        }
    }

    componentDidMount = () => {
        this.windowResized()
        window.addEventListener('resize', this.windowResized);
    }

    windowResized = () => {
        if (window.innerWidth <= 768 && !this.state.isMobile) {
            this.setState({
                isMobile: true
            })
        } else if (window.innerWidth > 768 && this.state.isMobile) {
            this.setState({
                isMobile: false
            })
        }
    }

    openCloseMenu = (value) => {
        this.setState({
            isMenuOpen: value
        })
    }

    openOptionsMenu = (value) => {
        this.setState({
            isOptionsOpen: value
        })
    }

    handleBridge = (value) => {
        window.open('http://app.debridge.finance/', '_self')
        return;
        this.openCloseMenu(false);

        this.setState({
            isBridgeOpen: value
        })
    }

    renderOptionsMenu = () => {
        if (this.state.isOptionsOpen) {
            return (
                <div className='menu-options'> 
                    <div className='top' />
                    <a href={baseUrls?.account + `/profile/${getCurrentUser()?.userName}`} className='element'>
                        My profile
                    </a>
                    <a href={baseUrls?.account + `/profile/settings`} className='element'>
                        Settings
                    </a>
                    <div className='element' style={{margin: 0}} onClick={logOut}>
                        Logout
                    </div>
                </div>
            )
        }
    }

    renderMobileVersion = () => {
        return (
            <div className='header-container'>
                {this.renderMobileMenu()}
                <div className='mobile-navbar-user'>
                    <a href={baseUrls?.map + '/map/free-navigation'} className='logo-container'>
                        <div className='logo' />
                    </a>

                    <div className='mobile-buttons'>
                        {
                            false && this.props.pageTitle === 'VERSE' &&
                            <div className='button svg info' onClick={this.props.toggleInfo}/>
                        }
                        {
                            this.props.isFromMap && this.props.isTutorial ?
                                <a href={baseUrls?.map + '/map/free-navigation'} className='button svg tutorial' />
                            :
                            this.props.isFromMap &&
                            <a href={baseUrls?.map + '/map/tutorial'} className='button svg navigation' />
                        }
                        <div className='button hamburger' onClick={() => this.openCloseMenu(!this.state.isMenuOpen)}>
                            <i class={!this.state.isMenuOpen ? 'bx bx-menu' : 'bx bx-x'} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderMobileMenu = () => {
        return (
            <div className={'mobile-menu' + (this.state.isMenuOpen ? ' open' : '')}>
                <div className='options-container'>
                    <div className='top'>
                        <a href={baseUrls + '/map/free-navigation'} className='element'>
                            <i class='bx bxs-map-alt' />
                            <div>
                                Verse World
                            </div>
                        </a>

                        {/*<Link to={'/news'} className='element' style={{animationDuration: '.5s'}}>
                            <i class='bx bx-news'></i>
                            <div>
                                News
                            </div>
                        </Link>*/}

                        {/*
                            <Link to={'/forum'} className='element' style={{animationDuration: '.6s'}}>
                                <i class='bx bxs-chat'></i>
                                <div>
                                    Forum
                                </div>
                            </Link>*/
                        }

                        {/*<a href='https://exchange.verseworld.com/' target="_blank" className='element'>
                            <div className={'button phantom'} />
                        </a>*/}

                        <a href={baseUrls?.download + '/download'} className='element' style={{animationDuration: '.7s'}}>
                            <i class='bx bx-download'></i>
                            <div>
                                Join The Dreamers
                            </div>
                        </a>

                        <div onClick={() => this.handleBridge(true)} target="_blank"  className='element' style={{animationDuration: '.7s'}}>
                            <img src="/debridge.jpg" style={{
                                marginRight: '30%',
                                width: '36px',
                                borderRadius: '50%'
                            }}/>
                            <div>
                                Bridge
                            </div>
                        </div>

                        {
                            isTokenValid() ?
                                <a href={baseUrls?.account + `/profile/${getCurrentUser()?.userName}`} className='element' style={{ animationDuration: '.8s' }}>
                                    <div className='profile' style={{ backgroundImage: `url(${getCurrentUser()?.profilePicture || 'https://verseworldstorage.blob.core.windows.net/verseweb/VerseWorld/empty.jpg'})` }} />
                                    <div>My Profile</div>
                                </a> :
                                <a href={baseUrls?.login + '/start/login'} className='element' style={{animationDuration: '.8s'}}>
                                    <i class='bx bxs-user'></i>
                                    <div>
                                        User
                                    </div>
                                </a>
                        }
                    </div>

                    {
                        isTokenValid() &&
                        <div className='log-out'>
                            <i class='bx bx-log-in'/>
                            <div>
                                Log-out
                            </div>
                        </div>
                    }

                </div>
            </div>
        )
    }

    renderHeader = () => {
        return (
            <div className='header-container'>
                <div className='navbar-user' style={{opacity: this.props.opacity}}>
                    <a href={baseUrls?.map + '/map/free-navigation'} className='element'>
                        <img src={'/logo.png'} className='logo' />
                    </a>

                    <a href={baseUrls?.map + '/map/free-navigation'} className='element'>
                        <div className={'button ' + (this.props.pageTitle === 'VERSE' ? 'active' : '')}>
                            <i class='bx bxs-map-alt' />
                            <div>
                                Verse World
                            </div>
                        </div>
                    </a>

                    {/*<Link to={'/news'} className='element'>
                        <div className={'button ' + (this.props.pageTitle === 'NEWS' ? 'active' : '')}>
                            <i class='bx bx-news'></i>
                            <div>
                                News
                            </div>
                        </div>
                    </Link>*/}

                    {/*
                        <Link to={'/forum'} className='element'>
                            <div className={'button ' + (this.props.pageTitle === 'FORUM' ? 'active' : '')}>
                                <i class='bx bxs-chat'></i>
                                <div>
                                    Forum
                                </div>
                            </div>
                        </Link>*/
                    }

                    <a href={baseUrls?.download + '/download'} className='element'>
                        <div className={'button ' + (this.props.pageTitle === 'DOWNLOAD' ? 'active' : '')}>
                            <i class='bx bx-download'></i>
                            <div>
                                Join The Dreamers
                            </div>
                        </div>
                    </a>

                    <div onClick={() => this.handleBridge(!this.state.isBridgeOpen)} target="_blank" className='element'>
                        <div className={'button ' + (this.state.isBridgeOpen ? 'active-hover' : '')}>
                            <img src="/debridge.jpg"
                            style={{
                                marginRight: '13%',
                                width: '27px',
                                borderRadius: '50%',
                                filter: 'unset'
                            }}/>
                            <div>
                                Bridge
                            </div>
                        </div>
                    </div>

                    {/*<a href='https://exchange.verseworld.com/' target="_blank" className='element'>
                        <div className={'button phantom'} />
                    </a>*/}
                    {
                        isTokenValid() ?
                        <>
                            <div onClick={() => this.openOptionsMenu(!this.state.isOptionsOpen)} className='element'>
                                <div className={'profile' + (this.props.pageTitle === 'PROFILE' ? ' active' : '')}  style={{ backgroundImage: `url(${getCurrentUser()?.profilePicture || 'https://verseworldstorage.blob.core.windows.net/verseweb/VerseWorld/empty.jpg'})` }} />
                                {this.renderOptionsMenu()}  
                            </div>
                        </> :
                        <>
                            <a href={baseUrls?.login + '/start/login'} className='element'>
                                <div className='profile active login' style={{backgroundImage: 'url(/login-icon.png)'}}>
                                </div>
                            </a>
                        </>
                    }
                </div>
            </div>
        )
    }

    handleVersion = () => {
        if (this.state.isMobile)
            return this.renderMobileVersion()
        return this.renderHeader()
    }

    render() {
        return (
            <>
                {this.handleVersion()}
                {this.state.isNFTModalOpen && <PhantomModal />}
                {this.state.isBridgeOpen && <ModalBridge closeModal={this.handleBridge}/>}
            </>
        ) 
    }
}
